import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./Store/store";
import App from "./App";

import { BrowserRouter, Routes, Route } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<BrowserRouter>
		<Provider store={store}>
			<Routes>
				<Route path="/*" element={<App />} />
			</Routes>
		</Provider>
	</BrowserRouter>
);
